import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ModuleWebsiteSearchPaginator } from '../../interfaces/module-website-search-paginator'

@Component({
  selector: 'dmmp-search-paginator',
  templateUrl: './search-paginator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchPaginatorComponent {
  @Input() module: ModuleWebsiteSearchPaginator
  @Input() identifier: string
  @Input() defaultClass: string
  @Input() currentPage: number
  @Input() totalPages: number
  @Output() selectedPage: EventEmitter<number> = new  EventEmitter<number>()

}
